'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UploadFeedbackStyled = require('./UploadFeedbackStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// F3 (Upload-Feedback): wiederverwendbare 4-Zustands-Box. Sprachfreie Visuals (Spinner,
// Balken, %-Zahl, Haken/Ausrufezeichen); title/hint sind optionale ReactNodes, die der
// Consumer (ggf. lokalisiert) reinreicht -> keine backend-gekoppelten i18n-Keys noetig.
// Primaerer Live-Einsatz: uploading(+progress) im FileUploader-Overlay (echtes %).
var clamp = function clamp(n) {
  return Math.max(0, Math.min(100, Math.round(n)));
};

var UploadFeedback = function UploadFeedback(_ref) {
  var state = _ref.state,
      progress = _ref.progress,
      title = _ref.title,
      hint = _ref.hint;

  var hasProgress = state === 'uploading' && typeof progress === 'number';
  return _react2.default.createElement(
    _UploadFeedbackStyled.FeedbackBox,
    { state: state, 'data-testid': 'upload-feedback', 'data-state': state },
    _react2.default.createElement(
      _UploadFeedbackStyled.IconBubble,
      { state: state },
      state === 'uploading' ? _react2.default.createElement(_UploadFeedbackStyled.InlineSpinner, { 'data-testid': 'upload-feedback-spin' }) : _react2.default.createElement(
        _UploadFeedbackStyled.Glyph,
        { state: state },
        state === 'success' && '✓',
        state === 'error' && '!',
        state === 'idle' && '↑'
      )
    ),
    title != null && _react2.default.createElement(
      _UploadFeedbackStyled.Title,
      null,
      title
    ),
    hasProgress && _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _UploadFeedbackStyled.ProgressTrack,
        null,
        _react2.default.createElement(_UploadFeedbackStyled.ProgressBar, {
          'data-testid': 'upload-feedback-bar',
          style: { width: clamp(progress) + '%' }
        })
      ),
      _react2.default.createElement(
        _UploadFeedbackStyled.Percent,
        null,
        clamp(progress) + '%'
      )
    ),
    hint != null && _react2.default.createElement(
      _UploadFeedbackStyled.Hint,
      { state: state },
      hint
    )
  );
};

UploadFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  state: _propTypes2.default.oneOf(['idle', 'uploading', 'success', 'error']),
  progress: _propTypes2.default.number,
  title: _propTypes2.default.node,
  hint: _propTypes2.default.node
} : {};

UploadFeedback.defaultProps = {
  state: 'idle',
  progress: null,
  title: null,
  hint: null
};

exports.default = UploadFeedback;
module.exports = exports['default'];